import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CreateUpdateFloorPlanRequest, DeleteFloorPlanRequest, FloorPlan } from '@shared/floor-plan/models';
import { ApiClientService } from '@tablesready/api-client';

@Injectable({providedIn: 'root'})
export class FloorPlanApiService {
  private readonly basePath = '/v.1/floor-plan';

  constructor(private readonly http: ApiClientService) { }

  getList(): Observable<FloorPlan[]> {
    return this.http.get<FloorPlan[]>(this.basePath);
  }

  create(data: CreateUpdateFloorPlanRequest): Observable<FloorPlan> {
    return this.http.post<FloorPlan>(this.basePath, data);
  }

  updateById(id: string, data: CreateUpdateFloorPlanRequest): Observable<FloorPlan> {
    return this.http.put<FloorPlan>(`${this.basePath}/${id}`, data);
  }

  deleteById(id: string, deleteResources = false): Observable<FloorPlan | null> {
    const body: DeleteFloorPlanRequest = {
      deleteResources: deleteResources || undefined,
    };

    return this.http.delete<FloorPlan | null>(`${this.basePath}/${id}`, { body } as any);
  }
}
